export const headerEntities = `
    <!ENTITY zwnj "&#8204;">
    <!ENTITY aring "å">
    <!ENTITY yen "¥">
    <!ENTITY ograve "ò">
    <!ENTITY Chi "&#935;">
    <!ENTITY delta "&#948;">
    <!ENTITY rang "&#9002;">
    <!ENTITY trade "&#8482;">
    <!ENTITY Ntilde "Ñ">
    <!ENTITY upsih "&#978;">
    <!ENTITY Yacute "Ý">
    <!ENTITY Atilde "Ã">
    <!ENTITY radic "&#8730;">
    <!ENTITY otimes "&#8855;">
    <!ENTITY aelig "æ">
    <!ENTITY oelig "&#339;">
    <!ENTITY equiv "&#8801;">
    <!ENTITY ni "&#8715;">
    <!ENTITY Psi "&#936;">
    <!ENTITY auml "ä">
    <!ENTITY cup "&#8746;">
    <!ENTITY Acirc "Â">
    <!ENTITY Epsilon "&#917;">
    <!ENTITY minus "&#8722;">
    <!ENTITY otilde "õ">
    <!ENTITY Icirc "Î">
    <!ENTITY Eacute "É">
    <!ENTITY Oacute "Ó">
    <!ENTITY sbquo "&#8218;">
    <!ENTITY Prime "&#8243;">
    <!ENTITY oslash "ø">
    <!ENTITY psi "&#968;">
    <!ENTITY Kappa "&#922;">
    <!ENTITY rsaquo "&#8250;">
    <!ENTITY acute "´">
    <!ENTITY uacute "ú">
    <!ENTITY sigmaf "&#962;">
    <!ENTITY lrm "&#8206;">
    <!ENTITY zwj "&#8205;">
    <!ENTITY cedil "¸">
    <!ENTITY Xi "&#926;">
    <!ENTITY uml "¨">
    <!ENTITY not "¬">
    <!ENTITY kappa "&#954;">
    <!ENTITY AElig "Æ">
    <!ENTITY prime "&#8242;">
    <!ENTITY Tau "&#932;">
    <!ENTITY lceil "&#8968;">
    <!ENTITY iquest "¿">
    <!ENTITY alefsym "&#8501;">
    <!ENTITY laquo "«">
    <!ENTITY dArr "&#8659;">
    <!ENTITY rdquo "&#8221;">
    <!ENTITY ge "&#8805;">
    <!ENTITY Igrave "Ì">
    <!ENTITY reg "®">
    <!ENTITY micro "µ">
    <!ENTITY shy "­">
    <!ENTITY sdot "&#8901;">
    <!ENTITY nbsp " ">
    <!ENTITY lfloor "&#8970;">
    <!ENTITY lArr "&#8656;">
    <!ENTITY Auml "Ä">
    <!ENTITY brvbar "¦">
    <!ENTITY Otilde "Õ">
    <!ENTITY szlig "ß">
    <!ENTITY clubs "&#9827;">
    <!ENTITY agrave "à">
    <!ENTITY Ocirc "Ô">
    <!ENTITY Theta "&#920;">
    <!ENTITY Pi "&#928;">
    <!ENTITY OElig "&#338;">
    <!ENTITY Scaron "&#352;">
    <!ENTITY thetasym "&#977;">
    <!ENTITY egrave "è">
    <!ENTITY sub "&#8834;">
    <!ENTITY iexcl "¡">
    <!ENTITY frac12 "½">
    <!ENTITY ordf "ª">
    <!ENTITY sum "&#8721;">
    <!ENTITY frac14 "¼">
    <!ENTITY prop "&#8733;">
    <!ENTITY Uuml "Ü">
    <!ENTITY ntilde "ñ">
    <!ENTITY sup "&#8835;">
    <!ENTITY asymp "&#8776;">
    <!ENTITY theta "&#952;">
    <!ENTITY prod "&#8719;">
    <!ENTITY nsub "&#8836;">
    <!ENTITY hArr "&#8660;">
    <!ENTITY rArr "&#8658;">
    <!ENTITY Oslash "Ø">
    <!ENTITY nu "&#957;">
    <!ENTITY THORN "Þ">
    <!ENTITY yuml "ÿ">
    <!ENTITY infin "&#8734;">
    <!ENTITY Mu "&#924;">
    <!ENTITY le "&#8804;">
    <!ENTITY thinsp "&#8201;">
    <!ENTITY ecirc "ê">
    <!ENTITY bdquo "&#8222;">
    <!ENTITY Sigma "&#931;">
    <!ENTITY fnof "&#402;">
    <!ENTITY Aring "Å">
    <!ENTITY tilde "&#732;">
    <!ENTITY frac34 "¾">
    <!ENTITY nabla "&#8711;">
    <!ENTITY mdash "&#8212;">
    <!ENTITY uarr "&#8593;">
    <!ENTITY permil "&#8240;">
    <!ENTITY Ugrave "Ù">
    <!ENTITY eta "&#951;">
    <!ENTITY Agrave "À">
    <!ENTITY sup1 "¹">
    <!ENTITY forall "&#8704;">
    <!ENTITY circ "&#710;">
    <!ENTITY eth "ð">
    <!ENTITY rceil "&#8969;">
    <!ENTITY iuml "ï">
    <!ENTITY gamma "&#947;">
    <!ENTITY lambda "&#955;">
    <!ENTITY harr "&#8596;">
    <!ENTITY Egrave "È">
    <!ENTITY xi "&#958;">
    <!ENTITY real "&#8476;">
    <!ENTITY divide "÷">
    <!ENTITY Ouml "Ö">
    <!ENTITY image "&#8465;">
    <!ENTITY hellip "&#8230;">
    <!ENTITY igrave "ì">
    <!ENTITY Yuml "&#376;">
    <!ENTITY ang "&#8736;">
    <!ENTITY sube "&#8838;">
    <!ENTITY loz "&#9674;">
    <!ENTITY frasl "&#8260;">
    <!ENTITY ETH "Ð">
    <!ENTITY lowast "&#8727;">
    <!ENTITY Nu "&#925;">
    <!ENTITY plusmn "±">
    <!ENTITY omega "&#969;">
    <!ENTITY chi "&#967;">
    <!ENTITY sup2 "²">
    <!ENTITY sup3 "³">
    <!ENTITY Aacute "Á">
    <!ENTITY cent "¢">
    <!ENTITY Iacute "Í">
    <!ENTITY oline "&#8254;">
    <!ENTITY Ecirc "Ê">
    <!ENTITY Beta "&#914;">
    <!ENTITY perp "&#8869;">
    <!ENTITY emsp "&#8195;">
    <!ENTITY there4 "&#8756;">
    <!ENTITY pi "&#960;">
    <!ENTITY iota "&#953;">
    <!ENTITY empty "&#8709;">
    <!ENTITY euml "ë">
    <!ENTITY notin "&#8713;">
    <!ENTITY Upsilon "&#933;">
    <!ENTITY para "¶">
    <!ENTITY epsilon "&#949;">
    <!ENTITY Delta "&#916;">
    <!ENTITY weierp "&#8472;">
    <!ENTITY uuml "ü">
    <!ENTITY part "&#8706;">
    <!ENTITY icirc "î">
    <!ENTITY bull "&#8226;">
    <!ENTITY omicron "&#959;">
    <!ENTITY upsilon "&#965;">
    <!ENTITY copy "©">
    <!ENTITY Iuml "Ï">
    <!ENTITY Lambda "&#923;">
    <!ENTITY spades "&#9824;">
    <!ENTITY ndash "&#8211;">
    <!ENTITY ensp "&#8194;">
    <!ENTITY ccedil "ç">
    <!ENTITY Ucirc "Û">
    <!ENTITY cap "&#8745;">
    <!ENTITY ocirc "ô">
    <!ENTITY mu "&#956;">
    <!ENTITY scaron "&#353;">
    <!ENTITY lsquo "&#8216;">
    <!ENTITY isin "&#8712;">
    <!ENTITY Zeta "&#918;">
    <!ENTITY supe "&#8839;">
    <!ENTITY deg "°">
    <!ENTITY and "&#8743;">
    <!ENTITY tau "&#964;">
    <!ENTITY pound "£">
    <!ENTITY curren "¤">
    <!ENTITY int "&#8747;">
    <!ENTITY ucirc "û">
    <!ENTITY rfloor "&#8971;">
    <!ENTITY crarr "&#8629;">
    <!ENTITY ugrave "ù">
    <!ENTITY exist "&#8707;">
    <!ENTITY cong "&#8773;">
    <!ENTITY Dagger "&#8225;">
    <!ENTITY oplus "&#8853;">
    <!ENTITY times "×">
    <!ENTITY atilde "ã">
    <!ENTITY piv "&#982;">
    <!ENTITY iacute "í">
    <!ENTITY Euml "Ë">
    <!ENTITY Phi "&#934;">
    <!ENTITY raquo "»">
    <!ENTITY lsaquo "&#8249;">
    <!ENTITY quot '"'>
    <!ENTITY Uacute "Ú">
    <!ENTITY Omicron "&#927;">
    <!ENTITY ne "&#8800;">
    <!ENTITY Iota "&#921;">
    <!ENTITY eacute "é">
    <!ENTITY rarr "&#8594;">
    <!ENTITY yacute "ý">
    <!ENTITY Rho "&#929;">
    <!ENTITY darr "&#8595;">
    <!ENTITY Alpha "&#913;">
    <!ENTITY zeta "&#950;">
    <!ENTITY Omega "&#937;">
    <!ENTITY acirc "â">
    <!ENTITY sim "&#8764;">
    <!ENTITY phi "&#966;">
    <!ENTITY diams "&#9830;">
    <!ENTITY macr "¯">
    <!ENTITY larr "&#8592;">
    <!ENTITY Ccedil "Ç">
    <!ENTITY ordm "º">
    <!ENTITY uArr "&#8657;">
    <!ENTITY beta "&#946;">
    <!ENTITY Eta "&#919;">
    <!ENTITY rho "&#961;">
    <!ENTITY aacute "á">
    <!ENTITY alpha "&#945;">
    <!ENTITY rlm "&#8207;">
    <!ENTITY middot "·">
    <!ENTITY Gamma "&#915;">
    <!ENTITY euro "&#8364;">
    <!ENTITY lang "&#9001;">
    <!ENTITY dagger "&#8224;">
    <!ENTITY rsquo "&#8217;">
    <!ENTITY thorn "þ">
    <!ENTITY ouml "ö">
    <!ENTITY or "&#8744;">
    <!ENTITY Ograve "Ò">
    <!ENTITY sect "§">
    <!ENTITY ldquo "&#8220;">
    <!ENTITY hearts "&#9829;">
    <!ENTITY sigma "&#963;">
    <!ENTITY oacute "ó">
    <!ENTITY quot "$quot;">
    <!ENTITY amp "$amp;">
    <!ENTITY apos "$apos;">
    <!ENTITY lt "$lt;">
    <!ENTITY gt "$gt;"> `;
